import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { pagesState, mySession, GetOrderAsync, pageDetails, fileInfo, checkSessionAsync, CancelOrderItemAsync, checkLoginAsync, initiateAction } from './controller';
import useDynamicRefs from 'use-dynamic-refs';
import moment from 'moment';
import { Tabs, Tab, Modal } from 'react-bootstrap';

export function RequestDetails() {

    const dispatch = useDispatch();
    const page_urlParams = useParams();
    const pages_state = useSelector(pagesState);
    const OrderDetails = useSelector(pageDetails);
    const my_Session = useSelector(mySession);
    const [getRef, setRef] = useDynamicRefs();


    var [showTitle, setshowTitle] = useState(null);
    var toggleTitle = (index) => {
        if (showTitle === index) {
            setshowTitle(null);
        } else {
            setshowTitle(index);
        }

    };

    var [showCancelItemModal, setshowCancelItemModal] = useState(null);
    var handleshowCancelItemModal = (index) => {
        if (showCancelItemModal === index) {
            setshowCancelItemModal(null);
        } else {
            setshowCancelItemModal(index);
        }

    };

    const convertToSeconds = (value) => {
        var d = new Date(0, 0, 0, 0, 0, 0, 0);
        d.setSeconds(value);
        return d;
    }

    const convertToMinsSecond = (input) => {
        var minutes = parseInt(input / 60, 10);
        var seconds = input % 60;

        return minutes + ' mins' + (seconds ? ' ' + seconds + ' sec' : '');
    }

    const getDeliveryMethod = (deliverItem, itemId) => {
        var method;
        if(deliverItem){
            deliverItem.forEach((dlvItem) => {
                dlvItem.DeliveryInfos.forEach((devInfo) => {
                    if (devInfo.OrderItemId === itemId) {
                        method = devInfo.MethodInstruction;
                    }
                })
               
            })
           
        }else{
            method = '';
        }

        return method;
    }

    const downloadFile = (fileName, fileUrl) => {
        var file = { name: fileName, url: fileUrl };
        dispatch(fileInfo(file));
        dispatch(checkSessionAsync());
    }

    const cancelItem = (item_id) => {
        var itemList = [];
        itemList.push(item_id);
        var data = {
            requestId: page_urlParams.orderId,
        }
        var cancel_data = [data, {
            OrderItemIds: itemList,
            StatusId: "2ddec370-8acc-4be4-9349-b6462c4978b0",
            LastModifiedUserId: ''
        }]

        dispatch(CancelOrderItemAsync(cancel_data));
        setshowCancelItemModal(null);
    }

    const GetOrderInfo=async ()=>{
        await dispatch(initiateAction());

        await dispatch(checkLoginAsync());

        await dispatch(GetOrderAsync({
            requestId: page_urlParams.orderId,
        }));
    }

    useEffect(() => {
        GetOrderInfo();
        // dispatch(initiateAction());
        // dispatch(checkLoginAsync());
        // var data = {
        //     requestId: page_urlParams.orderId,
        // }
        // dispatch(GetOrderAsync(data));
    }, []);


    return (
        <section id="requests">
            {(pages_state.status !== 'idle' || pages_state.status === 'rejected') && <div className="position-fixed loadingScreen d-flex justify-content-center align-items-center"><img src="./images/loading.gif" className="icons-loading" alt="" /></div>}
            <div className="container-fluid mt-3 minHeight">
                <div className="container">

                    <div className="row">
                        <div className="col-md-12">
                            <div className="text-center">
                                <h2 className="pageTitle mt-2">Request Order: {OrderDetails && OrderDetails.OrderCode}</h2>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-5">
                        <div className="col-md-12">
                            <div className="d-flex justify-content-start align-items-center flex-wrap">
                                <div className="fw-bold text-18 theme-color">
                                    <span className="material-icons-outlined align-middle pb-1">near_me</span> Navigation: &nbsp;
                                </div>
                                <Link to={'/requests'} className="btn btn-outline-primary me-2 mb-2"><span className="material-icons-outlined align-middle pb-1">reply</span> My Request List</Link>
                                {pages_state && pages_state.payCount > 0 && <div className="position-relative">
                                    <Link to={`/my-invoices/${page_urlParams.orderId}`} className="btn btn-outline-primary me-2 mb-2"><span className="material-icons-outlined align-middle pb-1">receipt</span> Invoices</Link>
                                    <div className="position-absolute badge">
                                        {pages_state && pages_state.payCount ? pages_state.payCount : ''}
                                    </div>
                                </div>}
                            </div>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col-md-12">
                            {OrderDetails && OrderDetails.Items && OrderDetails.Items.map((data, index) => {
                                return (
                                    <div className="card overflow-hidden mb-3" key={index}>
                                        <div className="card-header text-light py-3 px-3 d-flex justify-content-between align-items-center flex-row flex-wrap">
                                            <div className="mb-2 mb-md-0">
                                                {data.Description} {data.Format && data.Format === 'PHY' && <span>- Physical Merchandise</span>} {data.TypeDescription && <span>({data.TypeDescription})</span>}
                                            </div>
                                            <div>
                                                {data.StatusCode === 'PP' && !data.IsExpired && <Link to={`/my-invoices/${page_urlParams.orderId}`} className="btn btn-light me-2 mb-2 mb-md-0">Proceed to Payment <span className="material-icons-outlined align-middle pb-1 ps-1">credit_card</span></Link>}
                                                {data.PaymentStatus === 'none' && data.TypeDescription === 'VO' && <button onClick={() => handleshowCancelItemModal(index)} className="btn btn-danger mb-2 mb-md-0">Cancel Request <span className="material-icons-outlined align-middle pb-1 ps-1">cancel</span></button>}
                                                <Modal show={showCancelItemModal === index} centered backdrop="static" size="md">
                                                    <Modal.Header>
                                                        <Modal.Title>Cencel Request Confirmation</Modal.Title>
                                                    </Modal.Header>
                                                    <Modal.Body>
                                                        <div>
                                                            Are you sure you want to cancel this order item?
                                                        </div>
                                                    </Modal.Body>
                                                    <Modal.Footer>
                                                        <button className="btn btn-danger" onClick={() => cancelItem(data.OrderItemId)}>Confirm</button>
                                                        <button className="btn btn-secondary" onClick={() => handleshowCancelItemModal(index)}>Cancel</button>
                                                    </Modal.Footer>
                                                </Modal>
                                            </div>
                                        </div>

                                        <div className="card-body">
                                            <div className="card-content d-flex justify-content-between w-100 flex-wrap">
                                                <div className="w-75">
                                                    <p className="theme-color">{data.ItemCode}</p>
                                                    {data.SourceTitle && <p className="theme-color text-20 cursor_pointer" onClick={() => toggleTitle(index)}>{data.SourceTitle} <span className="material-icons-outlined align-middle">{showTitle === index ? 'expand_more' : 'expand_less'}</span></p>}
                                                    {showTitle === index &&
                                                        <div className="mt-3">
                                                            <p>
                                                                <a className="theme-color" href={data.SourceUrl} title="Visit site" target="_blank" rel="noreferrer">
                                                                    {data.SourceUrl}
                                                                </a>
                                                            </p>
                                                            <p>
                                                                <span className="text-dark">Resource Reference No:</span> <span className="theme-color">{data.SourceNo}</span>
                                                            </p>
                                                        </div>
                                                    }
                                                    {!data.SourceTitle &&
                                                        <div>
                                                            {data.SchoolName && <p className="theme-color cursor_pointer">
                                                                <span className="text-dark">Name of School:</span>
                                                                <span className="theme-color"> {data.SchoolName}</span>
                                                            </p>}
                                                            {data.SearchFromDate && <p className="theme-color cursor_pointer">
                                                                <span className="text-dark">Search Date Range:</span>
                                                                <span className="theme-color">{moment(data.SearchFromDate).format('DD MMM yyyy')} - {moment(data.SearchToDate).format('DD MMM yyyy')}</span>
                                                            </p>}
                                                        </div>}

                                                    {/* { data.CategoryCode === 'AP' && data.SourceId && <p>
                                                                    <span className="text-dark">Preview:</span>
                                                                    <cms-thumbnail data-uuid="{{item.SourceId}}"></cms-thumbnail>
                                                                </p> } */}
                                                    {data.Format && data.Format !== 'PHY' && <p>
                                                        <span className="text-dark">Format:</span>
                                                        <span className="theme-color"> {data.Format}</span>
                                                    </p>}
                                                    {data.ActualDuration > 0 && <p>
                                                        <span className="text-dark">Selected Time: </span>
                                                        <span className="theme-color">
                                                            {moment(convertToSeconds(data.ActualStartTime)).format('HH:mm:ss')} - {moment(convertToSeconds(data.ActualEndTime)).format('HH:mm:ss')}
                                                        </span>
                                                    </p>}
                                                    {data.SelectedDuration > 0 && <p>
                                                        <span className="text-dark">Total Duration: </span>
                                                        <span className="theme-color">
                                                            {convertToMinsSecond(data.ActualDuration)}
                                                        </span>
                                                    </p>}
                                                    {data.FirstFewWords && <p>
                                                        <span className="text-dark">First Few Words: </span>
                                                        <span className="theme-color">
                                                            {data.FirstFewWords}
                                                        </span>
                                                    </p>}
                                                    {data.LastFewWords && <p>
                                                        <span className="text-dark">Last Few Words: </span>
                                                        <span className="theme-color">
                                                            {data.LastFewWords}
                                                        </span>
                                                    </p>}
                                                    {data.Language && <p>
                                                        <span className="text-dark">Language: </span>
                                                        <span className="theme-color">
                                                            {data.Language}
                                                        </span>
                                                    </p>}
                                                    {data.ActualTotalPages > 0 && <p>
                                                        <span className="text-dark">Total Pages: </span>
                                                        <span className="theme-color">
                                                            {data.ActualTotalPages}
                                                        </span>
                                                    </p>}
                                                    {data.ActualPages > 0 && <p>
                                                        <span className="text-dark">Selected Pages: </span>
                                                        <span className="theme-color">
                                                            {data.ActualPages}{data.SelectedPageCount && <span> ({data.SelectedPageCount} pages)</span>}
                                                        </span>
                                                    </p>}
                                                    {data.HusbandName && <p>
                                                        <span className="text-dark">Name of Husband: </span>
                                                        <span className="theme-color">
                                                            {data.HusbandName}
                                                        </span>
                                                    </p>}
                                                    {data.WifeName && <p>
                                                        <span className="text-dark">Name of Wife: </span>
                                                        <span className="theme-color">
                                                            {data.WifeName}
                                                        </span>
                                                    </p>}
                                                    {data.SearchFromYear && <p>
                                                        <span className="text-dark">Search Year(s): </span>
                                                        <span className="theme-color">
                                                            {data.SearchFromYear} - {data.SearchToYear}
                                                        </span>
                                                    </p>}

                                                </div>
                                                <div className="d-flex align-items-start justify-content-end mt-3 w-25">
                                                    <p className="text-right">
                                                        <span className="text-dark">Status:</span> <span className="theme-color">{data.PublicDescription}</span>
                                                        {data.StatusCode === 'PP' && data.IsExpired && <span> (<span className="value text-danger">Expired</span>)</span>}
                                                    </p>
                                                </div>
                                                {(data.StatusCode === 'PC' || data.StatusCode === 'CM') && <div className="flex-grow-1 mt-3" style={{ flexBasis: '100%' }}>
                                                    {data.Attachments && data.Attachments.length > 0 &&
                                                        <div className="overflow-auto">
                                                            <table className="table table-bordered">
                                                                <thead style={{ backgroundColor: '#F4F4F4' }}>
                                                                    <tr>
                                                                        <th width="60%">File Name</th>
                                                                        <th width="20%">Expiry Date</th>
                                                                        <th width="20%">Remarks</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {data.Attachments.filter((attach) => attach.IsActive).map((attach, attach_index) => {
                                                                        return (
                                                                            <tr key={attach_index}>
                                                                                <td>{attach.FileName}</td>
                                                                                <td>{moment(attach.ExpirationDate).format('DD-MM-YYYY hh:mm a')}</td>
                                                                                <td>
                                                                                    {attach.DownloadUrl && <button className={'btn btn-primary d-block'} onClick={() => downloadFile(attach.FileName, attach.DownloadUrl)}>Download</button>}
                                                                                    
                                                                                    {!attach.DownloadUrl && data.TypeCode !== 'AP' &&
                                                                                        <div>
                                                                                            {attach.IsExpired ? "Expired" : !attach.IsAvailable ? "Processing" : !attach.IsAccessible ? getDeliveryMethod(OrderDetails && OrderDetails.DeliveryOrders && OrderDetails.DeliveryOrders.length > 0 ? OrderDetails.DeliveryOrders : '', data.OrderItemId) : ''}
                                                                                        </div>}
                                                                                    {!attach.DownloadUrl && data.TypeCode === 'AP' &&
                                                                                        <div>{data.MethodInstruction}
                                                                                        </div>
                                                                                    }
                                                                                </td>
                                                                            </tr>
                                                                        )
                                                                    })}

                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    }
                                                    {data.MethodCode === 'LOCK-HQ' && <div className="table-responsive flex-grow-1 mt-3" style={{ flexBasis: '100%' }}>
                                                        <table className="table table-bordered">
                                                            <thead style={{ backgroundColor: '#F4F4F4' }}>
                                                                <tr>
                                                                    <th width="60%">File Name</th>
                                                                    <th width="20%">Expiry Date</th>
                                                                    <th width="20%">Remarks</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td></td>
                                                                    <td>{moment(data.DelvOrderDueDate).format('DD-MM-YYYY hh:mm a')}</td>
                                                                    <td>
                                                                        <span>{data.MethodInstruction}</span>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>}
                                                </div>}
                                            </div>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}





